import * as React from 'react';

import { DownSmall as ArrowIcon } from '../../../icons';
import { Styled } from './styled';

export const OpenArrowButton = (props) => {
  const { isOpen, onClick } = props;
  return (
    <Styled.Container isOpen={isOpen} onClick={onClick}>
      <ArrowIcon />
    </Styled.Container>
  );
};
